import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/lib/stores/store';

export type SendJsonMessage = <T = unknown>(
  jsonMessage: T,
  keep?: boolean,
) => void;

type WebsocketState = {
  isConnected: boolean;
  isFirstConnected: boolean;
  sendJsonMessage: SendJsonMessage;
};
type StateState = {
  websocketState: WebsocketState;
};
const stateInitState: StateState = {
  websocketState: {
    isConnected: false,
    isFirstConnected: false,
    sendJsonMessage: () => {},
  },
};
const stateSlice = createSlice({
  name: 'stateSlice',
  initialState: stateInitState,
  reducers: {
    setWebsocketState: (state, action: { payload: WebsocketState }) => {
      state.websocketState = action.payload;
    },
    setSendJsonMessage: (state, action: { payload: SendJsonMessage }) => {
      state.websocketState.sendJsonMessage = action.payload;
    },
  },
});
export const reduxWebsocketState = (state: RootState) =>
  state.state.websocketState;

export const reduxSendJsonMessage = (state: RootState) =>
  state.state.websocketState.sendJsonMessage;

export const { setWebsocketState, setSendJsonMessage } = stateSlice.actions;
export default stateSlice.reducer;
